function fitMsgText(msg) {
  msg.style.setProperty('--msg-scale', 1);
  requestAnimationFrame(() => {
    const bar = msg.closest('.en-tier-bar');
    const available = bar.offsetWidth - 48;
    const actual = msg.scrollWidth;
    if (actual > available) {
      msg.style.setProperty('--msg-scale', (available / actual).toFixed(3));
    }
  });
}

function updateTierBar(cartTotal) {
  const bar = document.querySelector('.en-tier-bar');
  if (!bar) return;

  const tier1 = parseInt(bar.dataset.tier1, 10);
  const tier2 = parseInt(bar.dataset.tier2, 10);

  const fill = bar.querySelector('.en-tier-fill');
  const msg = bar.querySelector('.en-tier-msg');
  const dot1 = bar.querySelector('.en-marker1 .en-tier-dot');
  const dot2 = bar.querySelector('.en-marker2 .en-tier-dot');
  const reward1 = bar.querySelector('.en-reward[data-tier="1"]');
  const reward2 = bar.querySelector('.en-reward[data-tier="2"]');

  const pct = Math.min((cartTotal / tier2) * 100, 100);
  const t1 = cartTotal >= tier1;
  const t2 = cartTotal >= tier2;

  fill.style.width = pct + '%';
  fill.classList.toggle('en-tier2-active', t2);
  dot1.classList.toggle('is-reached', t1);
  dot2.classList.toggle('is-reached', t2);
  dot2.classList.toggle('tier2', t2);
  reward1.classList.toggle('is-reached', t1);
  reward2.classList.toggle('is-reached', t2);

  const fmt = cents => 'R' + Math.ceil(cents / 100).toLocaleString('en-ZA');

  if (t2) {
    msg.className = 'en-tier-msg is-unlocked';
    msg.innerHTML = 'Free shipping and 15% off — applied.';
    reward1.querySelector('span').textContent = 'Free shipping ✓';
    reward2.querySelector('span').textContent = '15% off ✓';
  } else if (t1) {
    msg.className = 'en-tier-msg';
    msg.innerHTML = 'Spend <strong>' + fmt(tier2 - cartTotal) + '</strong> more for <strong>15% off</strong>';
    reward1.querySelector('span').textContent = 'Free shipping ✓';
    reward2.querySelector('span').textContent = '15% off · R5,000';
  } else {
    msg.className = 'en-tier-msg';
    msg.innerHTML = 'Spend <strong>' + fmt(tier1 - cartTotal) + '</strong> more for <strong>free shipping </strong>';
    reward1.querySelector('span').textContent = 'Free shipping · R500';
    reward2.querySelector('span').textContent = '15% off · R5,000';
  }

  fitMsgText(msg);
}

const _fetch = window.fetch;
window.fetch = function(...args) {
  const url = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';
  const isCartChange = /\/cart\/(add|change|update|clear)\.js/.test(url);

  const result = _fetch.apply(this, args);

  if (isCartChange) {
    result.then(res => res.clone().json()).then(data => {
      if (/\/cart\/add\.js/.test(url)) {
        fetch('/cart.js').then(r => r.json()).then(cart => {
          updateTierBar(cart.total_price);
        });
      } else if (data.total_price !== undefined) {
        updateTierBar(data.total_price);
      }
    });
  }

  return result;
};

// Initial render on page load
fetch('/cart.js').then(r => r.json()).then(cart => {
  updateTierBar(cart.total_price);
});